import React, {useEffect} from 'react';
import Header from "../components/Header";
import CustomeNavbar from "../components/CustomeNavbar";
import Footer from "../components/Footer";
import PengaduanContent from "../contents/PengaduanContent";
import ToTop from "../components/ToTop";

const Pengaduan = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <Header />
            <CustomeNavbar />
            <PengaduanContent />
            <ToTop />
            <Footer />
        </div>
    );
};

export default Pengaduan;